
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/payment-status",
      function () {
        return require("private-next-pages/payment-status.tsx");
      }
    ]);
  